<template>
  <div>
    <b-form>
      <b-form-group label="Semester" label-class="control-label workload-course-label"
        :class="{ 'invalid-group': $v.form.termId.$error }">
        <b-form-select :options="terms" v-model="form.termId" value-field="termId"
          text-field="description"></b-form-select>
        <span v-if="$v.form.termId.$error" class="span-feedback invalid-feedback">
          Please select a semester.
        </span>
      </b-form-group>

      <b-form-group v-if="!workloadFaculty" label="Status" label-class="control-label workload-course-label"
        :class="{ 'invalid-group': $v.form.statusId.$error }">
        <b-form-select :options="statuses" v-model="form.statusId" value-field="id" text-field="name"></b-form-select>
        <span v-if="$v.form.statusId.$error" class="span-feedback invalid-feedback">
          Please select a status.
        </span>
      </b-form-group>

      <b-form-group v-if="!workloadFaculty" label="Faculty" label-class="control-label workload-course-label"
        class="mb-2">
        <autocomplete :source="usersApi" :inputClass="{ 'form-control': true, 'is-invalid': $v.form.asuriteId.$error }"
          resultsValue="asuriteId" :resultsDisplay="userDisplay" ref="userAutocomplete" @selected="selectUser"
          credentials="include" :request-headers="requestHeaders"></autocomplete>
        <span class="span-feedback invalid-feedback" v-if="$v.form.asuriteId.$error">You must select a faculty.</span>
      </b-form-group>

      <b-form-group aria-describedby="number-of-classes-help" label="Number of Classes"
        label-class="control-label workload-course-label" :class="{ 'invalid-group': $v.form.numberOfCourses.$error }">
        <b-form-input v-model="form.numberOfCourses"
          :class="{ 'is-invalid': $v.form.numberOfCourses.$error }"></b-form-input>
      </b-form-group>

      <b-form-group label="Reason" label-class="control-label workload-course-label">
        <b-form-textarea :rows="3" placeholder="Enter notes..." v-model="form.reason"></b-form-textarea>
      </b-form-group>

      <b-alert show variant="info">
        Please upload documentation justifying the requested course equivalent (e.g., a scanned email or letter).
      </b-alert>

      <!-- can only upload files when creating a new request -->
      <b-form-file v-if="!form.id" id="supporting-file-input" class="input-group ml-2" placeholder="Choose Files"
        v-model="file" multiple></b-form-file>

      <span v-if="$v.form.$error" class="span-feedback invalid-feedback">
        All fields must be filled out.
      </span>
    </b-form>

  </div>
</template>

<script>
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import Autocomplete from "@/components/autocomplete.vue";

import { required, integer } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      discussed: false,
      grant: {
        grantNumber: null,
        grantPercentage: null
      },

      form: {
        id: 0,
        termId: null,
        statusId: null,
        asuriteId: null,
        numberOfCourses: null,
        term: {
          description: ""
        },
        reason: null
      },
      file: null,
      requestHeaders: { "X-Requested-With": "XMLHttpRequest" }
    };
  },
  components: {
    Autocomplete
  },
  props: {
    value: {
      type: Boolean,
      required: false
    },
    item: {
      type: Object,
      required: false
    },
    terms: {
      type: Array,
      required: true
    },
    statuses: {
      type: Array,
      required: false,
      default: () => []
    },
    workloadFaculty: {
      type: String,
      required: false
    }
  },

  computed: {
    usersApi: function () {
      return process.env.VUE_APP_BASE_URI + "/api/employees/search?search=";
    }
  },

  watch: {
    value: function () {
      if (this.value) {
        this.$v.form.$touch();
        if (!this.$v.form.$error) {
          console.log("Emitting complete event");
          this.$emit("complete", { form: this.form, files: this.file });
          this.$v.$reset();
          this.form = {
            id: 0,
            termId: 0,
            asuriteId: null,
            numberOfClasses: null,
            term: {
              description: ""
            },
            reason: null
          };
          if (this.$refs.userAutocomplete) {
            this.$refs.userAutocomplete.display = "";
          }
        } else {
          this.$emit("input", false);
        }
      }
    },
    item: function () {
      if (this.item) {
        this.setForm(this.item);
      }
    }
  },

  validations() {
    var validations = {
      form: {
        termId: { required },
        statusId: { required },
        asuriteId: { required },
        numberOfCourses: { required, integer }
      }
    };

    return validations;
  },

  methods: {
    setForm: function (item) {
      // set values
      this.form = _.clone(item);
      if (!this.workloadFaculty) {
        this.$refs.userAutocomplete.display = this.userDisplay(this.form);
      }
    },
    userDisplay: function (user) {
      return (
        user.firstName +
        " " +
        user.lastName +
        " (" +
        user.asuriteId +
        ")" +
        (user.employeeJobs && user.employeeJobs[0]
          ? " - " +
          user.employeeJobs[0].title +
          " - " +
          user.employeeJobs[0].department.description
          : "")

        // user.department +
        // " - " +
        // user.title
      );
    },
    selectUser: function (autoselectResponse) {
      this.form.asuriteId = autoselectResponse.selectedObject.asuriteId;
    }
  },

  mounted() {
    if (this.item) {
      this.setForm(this.item);
    } else {
      if (this.workloadFaculty) {
        this.form.asuriteId = this.workloadFaculty;
        this.form.statusId = this.statuses.find(
          status => status.name === "Submitted"
        ).id;
      }
    }
  }
};
</script>

<style scoped></style>
